<link rel="icon" type="image/x-icon" href="favicon.ico">
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
<link
    href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400;1,600&display=swap"
    rel="stylesheet">
<link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700&display=swap" rel="stylesheet">
<meta name="category" content="Invites" />
<link rel="icon" type="image/x-icon" href="favicon.ico" />

<link rel="apple-touch-icon" href="assets/images/apple-touch-icon.png">
<link rel="preconnect" href="https://fonts.gstatic.com">
<link href="https://fonts.googleapis.com/css2?family=Overlock:ital,wght@0,400;0,700;0,900;1,400;1,700;1,900&display=swap" rel="stylesheet">
<link href="https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap" rel="stylesheet">

<link rel="stylesheet" href="https://pub-f79427c950a84405a07a8998dcded99f.r2.dev/assets/css/indigo-pink.css" *appShellNoRender>
<!-- <link href="https://unpkg.com/aos@2.3.1/dist/aos.css" rel="stylesheet"> -->
<!-- <link href="https://fonts.cdnfonts.com/css/unicorn-pop" rel="stylesheet"> -->
<!-- <link href="//db.onlinewebfonts.com/c/ced04be705a49b9e55c4f582a011250c?family=Unicorn+Pop" rel="stylesheet" type="text/css" /> -->
<link href="https://fonts.googleapis.com/css2?family=Viaoda+Libre" rel="stylesheet" />

<div id="bodyStart" class="posts"></div>
<script type="text/javascript">
    var _captchaTries = 0;

    function recaptchaOnload() {
        _captchaTries++;
        if (_captchaTries > 9)
            return;
        if ($('.g-recaptcha').length > 0) {
            grecaptcha.render("recaptcha", {
                sitekey: '6LfLfaoZAAAAAP7Ii-EjW9EFTXVWlQKAdc-ZgAli',
                callback: function () {
                    console.log('recaptcha callback');
                }
            });
            return;
        }
        window.setTimeout(recaptchaOnload, 1000);
    }
</script>

<script>
    setTimeout(() => {
        $(window).on('scroll', function () {
            var scroll = $(window).scrollTop();
            if (scroll < 400) {
                $("#sticky-header").removeClass("sticky");
                $('#back-top').fadeIn(500);
            } else {
                $("#sticky-header").addClass("sticky");
                $('#back-top').fadeIn(500);
            }
        });

    }, 1000);
</script>

<router-outlet></router-outlet>

<style>
    .float {
        position: fixed;
        width: 45px;
        height: 45px;
        bottom: 3px;
        right: 33px;
        background-color: #25d366;
        color: #FFF;
        border-radius: 50px;
        text-align: center;
        font-size: 27px;
        box-shadow: 2px 2px 3px #999;
        z-index: 100;
    }

    .my-float {
        margin-top: 10px;
    }

    @media screen and (min-width: 320px) and (max-width: 767px) {
        .float {
            position: fixed;
            width: 50px;
            height: 50px;
            bottom: 70px;
            left: 15px;
            font-size: 30px;
        }

        .my-float {
            margin-top: 10px;
        }

        .hide {
            opacity: 0;
            left: -100%;
        }

        .show {
            opacity: 1;
            left: 0;
        }
    }
</style>
<!-- <script [src]="paypalClientURL" type="text/javascript">
</script> -->
<!-- <jjva-ngx-whatsapp-button [ngx_whatsapp_phone]="phone" [ngx_whatsapp_text]="whatsappTitle"></jjva-ngx-whatsapp-button> -->
<a [href]="whatsappLink" class="float" target="_blank" id="whatsappLink" aria-label="Whatsapp" *ngIf="showWhatsapp">
    <i class="fa fa-whatsapp my-float"></i>
</a>
<!-- <div id="tidio-chat" *ngIf="showTidioChat"></div> -->
<!-- <script src="//code.tidio.co/jnpn1ns4p7vsp63hgazda0ghbpoir4ac.js" async></script> -->
<!-- Start of 247invites Zendesk Widget script -->
<!-- <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=9ef9c4cd-e4f8-4a08-80d4-f83659766add">
</script> -->
<!-- End of 247invites Zendesk Widget script -->